import React, {useState} from 'react'
import homeIcon from '../../assets/svg/Group 30.svg'
import emailIcon from '../../assets/svg/emailIcon.svg'
import malakIcon from '../../assets/svg/Group -25.svg'
import logout from '../../assets/svg/navbar/logout.svg'
import settings from '../../assets/svg/navbar/settings.svg'
import member from '../../assets/svg/navbar/member.svg'
import session from '../../assets/svg/navbar/session.svg'
import courses from '../../assets/svg/navbar/courses.svg'
import db from '../../functions/firebase'
import ReactLoading from 'react-loading'

const navLi = [{img:homeIcon, text:"Home", toPage:"landing"},{img:member, text:"Team Members", toPage:'teamMembers'},{img:courses, text:"Courses"},{img:session, text:"Sessions"},{img:settings, text:"Preferences"},{img:logout, text:"Log out"}]
export default function Navbar({changePage}) {
    const [email, setEmail] = useState('')
    const [sent, setSent] = useState(false)
    const [loading, setLoading ] = useState(false)
    const handleChange =(e) => { 
        setEmail(e.target.value)
    }
    const onSubmit = () => { 
        if (email){

            setLoading(true)
            db.collection('emails').doc(email).set({email}).then(data => { 
                setLoading(false)
                setSent(true)
            }).catch(err=> {
                setLoading(false)
                alert('sorry something went wrong please try again later')
            })
        } 
    }
    return (
        <div className="navbar">
            <div className="header">
                <div className="image">
                    <img src={malakIcon} alt=""/>
                </div>
                <div className="userInfo">
                    <h1>Malak Musa</h1>
                    <p>Co-Founder at Habhab</p>
                </div>
            </div>
            <div className="nav">
                <ul>
                  {navLi.map(el =><li onClick={el.toPage?() => changePage(el.toPage):''} ><img src={el.img} alt=""/> {el.text}</li>)}
                </ul>
            </div>
            <div className="emailSection">
                {loading? <div className="loadingContainer">

                <ReactLoading
         type={'spin'} color={'#121212'} 
         height={'50px'} width={'50px'}
         /> 
         </div> 
         : 
         <>
         {
             sent? <h2 className="emailTitle">Thanks for subscribing to our newsletter!</h2>
             :
         <>
                <h2 className="emailTitle">This is a mockup,<br/> Sign up to stay in the loop</h2>
                <div className="emailInputs">
                    <img className={'emailIcon'} src={emailIcon} alt=""/> 
                    <input type="email" onChange={handleChange} /> 
                    <button className={'emailSubmit'} onClick={onSubmit}>Submit</button>
                </div>
                <p className="emailText">
                By signing up you agree to receive emails and updates about our products, service, and offerings
                </p>
                </>
}
            </>
        }
            </div>
        </div>
    )
}
